import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { Reveal } from "./ui";
export function Guarantee() {
  return <section id="garantia" className="w-full bg-[#eef6ff] px-4 py-10 sm:px-8 sm:py-16" data-id="element-87" data-mp="1o2vg4lt3wh4z">
      <Reveal className="mx-auto max-w-3xl" data-id="element-88" data-mp="222d9zfl9ekl7">
        <div className="flex flex-col items-center gap-5 rounded-3xl bg-white p-6 text-center shadow-[0_24px_60px_-34px_rgba(23,50,77,0.5)] sm:flex-row sm:gap-8 sm:p-10 sm:text-left" data-id="element-89" data-mp="221bvf151bfyq">
          <div className="flex h-20 w-20 flex-none items-center justify-center rounded-full border-4 border-dashed border-[var(--accent-green)]/40 bg-[var(--calm-green)] sm:h-24 sm:w-24" data-id="element-90" data-mp="19f0m923d46qb">
            <ShieldCheckIcon className="h-9 w-9 text-[var(--accent-green)] sm:h-11 sm:w-11" aria-hidden data-id="element-91" data-mp="1j6501yhaxljk" />
          </div>
          <div data-id="element-92" data-mp="1ebr3hsqwl8db">
            <h2 className="font-serif-display text-2xl font-semibold text-[var(--ink)] sm:text-3xl" data-id="element-93" data-mp="qo9geail2ygo">
              Garantía de paz familiar
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-94" data-mp="lon4q5ielq9z">
              Si en 7 días no encontrás al menos una estrategia que mejore tu día a día, te
              devolvemos tu inversión de acuerdo con las condiciones de compra.
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}